import React, { useEffect, useState } from 'react';

export default function Loading () {
  return (
    <>
      <div className='module_loading_w'>
        <div className='loading1' />
        <div className='loading2' />
        <div className='loading3' />
      </div>
    </>
  );
}
